import { useDispatch, useSelector } from 'react-redux';
import * as React from 'react';

import { FavoriteButton } from '../../components/FavoriteButton';
import { selectRecentlyViewedById } from '../../selectors/recentlyViewed';
import { deleteFromFavorite } from '../../thunk/recentlyViewed/deleteFromFavorite';
import { addToFavorite } from '../../thunk/recentlyViewed/addToFavorite';

interface IRecentlyViewedFavoriteButtonContainerProps {
  id: number;
}

export const RecentlyViewedFavoriteButtonContainer: React.FC<IRecentlyViewedFavoriteButtonContainerProps> = ({
  id,
}) => {
  const dispatch = useDispatch();
  const offer = useSelector(selectRecentlyViewedById(id));

  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      event.preventDefault();

      if (!offer) {
        return;
      }

      const action = offer.isFavorite ? deleteFromFavorite : addToFavorite;

      dispatch(action(offer));
    },
    [dispatch, offer],
  );

  if (!offer) {
    return null;
  }

  return <FavoriteButton onClick={handleClick} isActive={offer.isFavorite} />;
};
